// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"929":"css/app.7007","2861":"css/admin-app.7007"}[chunkId] + ".css";
};